import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-verification-header',
  templateUrl: './student-verification-header.component.html',
  styleUrls: ['./student-verification-header.component.scss']
})
export class StudentVerificationHeaderComponent implements OnInit {

  retrievedData: any;
  retrievedData1: any;

  ngOnInit(): void {
    this.retrievedData = localStorage.getItem('userName');
    this.retrievedData1 = localStorage.getItem('campusName');
  }

  logout() {
    const logoutPage = localStorage.getItem('logoutPage');
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }
}
